import React from 'react';
import styles from '../AppointmentManagement/AppointmentManagement.module.css';
import {Appointment} from 'externalAPIs/insurance-eligibility';

interface ActiveAppointmentSectionProps {
  appointment: Appointment;
}

export const ActiveAppointmentSection: React.FC<ActiveAppointmentSectionProps> = ({appointment}) => {
  return (
    <div className={styles.activeAppointmentSection}>
      <div key={appointment.appointmentId} className={styles.appointmentItem}>
        <div className={styles.appointmentItemContent}>
          <div className={styles.appointmentItemLeft}>
            <div className={styles.appointmentProfilePicture}>
              {appointment.avatarUrl ? (
                <img src={appointment.avatarUrl} alt={appointment.providerName} />
              ) : (
                <div className={styles.profilePicturePlaceholder} />
              )}
            </div>
            <div className={styles.appointmentItemInfo}>
              <div className={styles.appointmentProviderName}>{appointment.providerName}</div>
              <div className={styles.appointmentItemDate}>
                <span style={{display: 'flex', alignItems: 'center', gap: '4px'}}>
                  <svg width={21} height={16} viewBox="0 0 21 16" fill="none" style={{flexShrink: 0}}>
                    <path
                      d="M18.085 9.05a2.623 2.623 0 010-1.994l.088-.21c.56-1.33-.087-2.87-1.417-3.43l-.193-.087a2.562 2.562 0 01-1.418-1.418l-.07-.175A2.665 2.665 0 0011.63.32l-.175.07a2.67 2.67 0 01-2.012 0L9.286.32C7.973-.223 6.434.424 5.874 1.754l-.07.14a2.561 2.561 0 01-1.417 1.418l-.158.07c-1.312.56-1.96 2.099-1.4 3.428l.07.157a2.624 2.624 0 010 1.995l-.07.192c-.56 1.33.07 2.87 1.418 3.413l.175.07c.647.262 1.155.77 1.417 1.417l.087.193a2.614 2.614 0 003.412 1.434l.192-.088a2.67 2.67 0 012.012 0l.158.07c1.33.56 2.869-.088 3.429-1.418l.07-.14a2.562 2.562 0 011.417-1.417l.14-.053a2.612 2.612 0 001.418-3.43l-.088-.155zm-8.327 2.362l-3.412-2.87L7.396 7.3l2.169 1.837 3.831-4.549 1.243 1.05-4.881 5.774z"
                      fill="var(--color-web-purple1)"
                    />
                  </svg>
                  <strong>Sleep expert:</strong> {appointment.credentials}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
